import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useRoles } from '../../hooks/useRoles';

interface RoleGuardProps {
    children: React.ReactNode;
    requiredRoles: string[];
    requireAll?: boolean;
    fallback?: React.ReactNode;
    showFallback?: boolean;
}

export const RoleGuard: React.FC<RoleGuardProps> = ({
    children,
    requiredRoles,
    requireAll = false,
    fallback = <div className="text-mp-muted text-sm">Access denied</div>,
    showFallback = true,
}) => {
    const { user } = useAuth();
    const { hasRole, hasAnyRole } = useRoles();

    if (!user) {
        return showFallback ? <>{fallback}</> : null;
    }

    const hasAccess = requireAll
        ? requiredRoles.every((role) => hasRole(role))
        : hasAnyRole(requiredRoles);

    if (!hasAccess) {
        return showFallback ? <>{fallback}</> : null;
    }

    return <>{children}</>;
};
